import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useEditTag } from "../../hooks/useCrm";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { TagsLang } from "../../data/crmGeneralData";
const initvalue = {
  NameTag: null,
  ColorTag: null,
  StatusTag: null,
  IdTag: null,
};
export const EditTagModal = ({ show, handleClose, tag }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const tagsOptions = TagsLang?.map((res) => {
    return {
      value: res.value,
      label: res.label,
    };
  });
  useEffect(() => {
    if (tag) {
      setForm({
        ...form,
        IdTag: tag?.IdTag,
        ColorTag: tag?.ColorTag,
        NameTag: tag?.NameTag,
        StatusTag: tag?.StatusTag,
      });
    }
  }, [tag]);
  const { mutateAsync: EditTag } = useEditTag();
  const handleEditTag = async (data) => {
    await EditTag(data);
  };
  return (
    <BootstrapModal
      modaltitle="ویرایش برچسب"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <InputField1
            label="نام برچسب"
            value={form.NameTag}
            onChange={(e) => setForm({ ...form, NameTag: e.target.value })}
          />
        </div>
        <div className="col-12">
          <InputField1
            label="رنگ برچسب"
            type="color"
            onChange={(e) => setForm({ ...form, ColorTag: e.target.value })}
            value={form.ColorTag}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="زبان برچسب"
            res={tagsOptions}
            onChange={(e) => setForm({ ...form, StatusTag: e.value })}
            placeholder={
              tag?.StatusTag === "fa"
                ? "فارسی"
                : tag?.StatusTag === "en"
                ? "انگلیسی"
                : tag?.StatusTag === "ar"
                ? "عربی"
                : ""
            }
          />
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEditTag(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
